import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Self-host Inter + JetBrains Mono per brand-identity §6 (zero external
// font requests at runtime — matches the "your data stays in your browser"
// positioning). The variable Inter ships with all weights in one file.
import '@fontsource-variable/inter';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import App from './App';
import './index.css';

// Test-only WebSocket replacement. The mock is dynamic-imported so production
// builds tree-shake it out unless ?mockCsms=1 appears in the URL.
const urlParams = new URL(window.location.href).searchParams;
if (urlParams.get('mockCsms') === '1') {
  const { installMockCsmsWebSocket } = await import('./state/mockCsmsBrowser');
  installMockCsmsWebSocket();
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
